import type { ReactNode } from "react";
import NextLink from "next/link";
import clsx from "clsx";

import styles from "./Link.module.css";

type LinkType = "DEFAULT" | "EXTERNAL" | "ANCHOR";
type LinkVariant =
  | "LINK"
  | "BUTTON_BLUE"
  | "BUTTON_BLUE_LIGHT"
  | "BUTTON_BLACK"
  | "BUTTON_GRAY";

interface LinkProps {
  children: ReactNode;
  href: string;
  type?: LinkType;
  variant?: LinkVariant;
  className?: string;
}

export const Link = ({
  children,
  className,
  type = "DEFAULT",
  variant = "LINK",
  href,
}: LinkProps) => {
  if (!href) {
    console.error("Ссылке не передан href");
    return null;
  }

  const linkClassName = clsx(styles.link, styles[type], styles[variant], className);

  switch (type) {
    case "DEFAULT":
      return (
        <NextLink href={href} className={linkClassName}>
          {children}
        </NextLink>
      );
    case "ANCHOR":
      return (
        <a href={`#${href}`} className={linkClassName}>
          {children}
        </a>
      );
    case "EXTERNAL":
      return (
        <a
          target="_blank"
          href={href}
          rel="noopener noreferrer"
          className={linkClassName}
        >
          {children}
        </a>
      );
  }
};

/** @deprecated Use `Link` */
export const MyLink = Link;
